import React, {useState} from "react"
import {Link, useLocation, useNavigate} from "react-router-dom";
import rootStore from "../../stores/rootStore.js";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import {Alert, Card, Container, InputGroup} from "react-bootstrap";
import {Formik} from "formik";
import * as yup from "yup";
import bctcLogo from "../../images/BCTC_Logo_Horiz_small.png";
import {authApi} from "../../api/auth.js";
function LoginPage() {
    const schema = yup.object().shape({
        email: yup.string().email('Invalid email format').required(),
        password: yup.string().required(),
    });

    const [pageState, setPageState] = useState({pageError: null});
    let navigate = useNavigate();
    let location = useLocation();
    let authStore = rootStore.authenticationStore;
    let from = location.state?.from?.pathname || "/";

    React.useEffect(() => {
        const externalSession = new URLSearchParams(location.search).get("externalSession");
        if (externalSession) {
            authStore.completeExternalSession(externalSession).then(() => {
                navigate(from, {replace: true});
            }).catch(() => {
                setPageState(prevState => {
                    return {...prevState, pageError: "External login session expired. Please try LTSA login again."}
                });
            });
        }
    }, [location.search]);

    return (
        <div className="auth-layout">
            <Container style={{maxWidth: 720}}>
                <Card className="auth-card p-4 mx-auto">
                    <div className="auth-header">
                        <img src={bctcLogo} height="64" alt="BCTC logo" />
                        <h1 style={{fontFamily: "Bitter, Georgia, serif"}}></h1>
                    </div>
                    {pageState.pageError && (
                        <Alert key="pageError" variant="danger">
                            {pageState.pageError}
                        </Alert>
                    )}
                    <Formik
                        validationSchema={schema}
                        onSubmit={async (values, { setSubmitting }) => {
                            try {
                                try {
                                    await authStore.signIn(values.email, values.password)
                                    navigate(from, { replace: true });
                                } catch (e){
                                    setPageState(prevState => {return {...prevState, pageError: "Invalid username / password" }})
                                    console.error("Invalid username / password");
                                }
                            } finally {
                                setSubmitting(false);
                            }
                        }}
                        initialValues={{
                            email: '',
                            password: '',
                        }}
                    >
                        {({ handleSubmit, handleChange,touched, values, isSubmitting, errors }) => (
                            <Form noValidate onSubmit={handleSubmit}>
                                <Form.Group className="mb-3" controlId="email">
                                    <Form.Label>Email address</Form.Label>
                                    <InputGroup>
                                        <InputGroup.Text><i className="bi bi-envelope"></i></InputGroup.Text>
                                        <Form.Control
                                            name="email"
                                            onChange={handleChange}
                                            value={values.email}
                                            type="email"
                                            placeholder="Email"
                                            isInvalid={touched.email && !!errors.email}
                                        />
                                    </InputGroup>
                                    {touched.email && (<Form.Control.Feedback type="invalid">
                                        {errors.email}
                                    </Form.Control.Feedback>)}
                                </Form.Group>

                                <Form.Group
                                    className="mb-3"
                                    controlId="password"
                                >
                                    <Form.Label>Password</Form.Label>
                                    <InputGroup>
                                        <InputGroup.Text><i className="bi bi-lock"></i></InputGroup.Text>
                                        <Form.Control
                                            name="password"
                                            onChange={handleChange}
                                            value={values.password}
                                            type="password"
                                            placeholder="Password"
                                            isInvalid={touched.password && !!errors.password}
                                        />
                                    </InputGroup>
                                    {touched.password && (<Form.Control.Feedback type="invalid">
                                        {errors.password}
                                    </Form.Control.Feedback>)}
                                </Form.Group>
                                <div className="d-flex justify-content-end mb-3">
                                    <Link className="text-primary" to="/forgotPassword">
                                        Forgot password?
                                    </Link>
                                </div>
                                <div className="d-grid">
                                    <Button  type="submit" disabled={isSubmitting}>
                                        Login
                                    </Button>
                                </div>
                                <div className="d-grid mt-2">
                                    <Button
                                        type="button"
                                        variant="outline-secondary"
                                        onClick={() => window.location.assign(authApi.getLtsaStartUrl())}
                                    >
                                        Login With LTSA
                                    </Button>
                                </div>
                            </Form>
                        )}

                    </Formik>
                    <div className="auth-footer">
                        Don&apos;t have an account?{" "}
                        <Link to="/register" className="text-primary fw-bold">
                            Sign Up
                        </Link>
                    </div>
                </Card>
            </Container>
        </div>
    );
}

export default LoginPage
